// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar-indeterminate {
  height: 1rem;
  width: 55%;
  background: linear-gradient(
    90deg,
    #60b0e2,
    #4ac0c9,
    #4ac0c9,
    #4dd066,
    #6bcb27
  );
  position: relative;
  animation: move-indeterminate 1.5s linear infinite;
}

@keyframes move-indeterminate {
  0% {
    left: -20%;
    width: 30%;
  }
  15% {
    left: 5%;
    width: 40%;
  }
  25% {
    width: 50%;
    left: 20%;
  }
  50% {
    width: 65%;
    left: 40%;
  }
  75% {
    width: 45%;
    left: 65%;
  }
  85% {
    width: 50%;
    left: 90%;
  }
  100% {
    left: 100%;
    width: 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/views/indeterminate-progress-bar/indeterminate-progress-bar.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV;;;;;;;GAOC;EACD,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF","sourcesContent":[".progress-bar-indeterminate {\r\n  height: 1rem;\r\n  width: 55%;\r\n  background: linear-gradient(\r\n    90deg,\r\n    #60b0e2,\r\n    #4ac0c9,\r\n    #4ac0c9,\r\n    #4dd066,\r\n    #6bcb27\r\n  );\r\n  position: relative;\r\n  animation: move-indeterminate 1.5s linear infinite;\r\n}\r\n\r\n@keyframes move-indeterminate {\r\n  0% {\r\n    left: -20%;\r\n    width: 30%;\r\n  }\r\n  15% {\r\n    left: 5%;\r\n    width: 40%;\r\n  }\r\n  25% {\r\n    width: 50%;\r\n    left: 20%;\r\n  }\r\n  50% {\r\n    width: 65%;\r\n    left: 40%;\r\n  }\r\n  75% {\r\n    width: 45%;\r\n    left: 65%;\r\n  }\r\n  85% {\r\n    width: 50%;\r\n    left: 90%;\r\n  }\r\n  100% {\r\n    left: 100%;\r\n    width: 30%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
